import React from "react";
import { Checkbox, Spin } from "antd";
import { users } from '@services/api'
import { alertPopup } from "@utils/popup";


class CheckMonthlyCommission extends React.Component {

    constructor (props) {
        super(props)
        this.state = {
            monthly_commission: false,
            waiting: false
        }
    }

    componentDidUpdate(prevProps) {
        const prevValue = prevProps.agentInfo ? prevProps.agentInfo.monthly_commission : undefined
        const nextValue = this.props.agentInfo ? this.props.agentInfo.monthly_commission : undefined

        if (prevValue === undefined && nextValue !== undefined) {
            this.setState({ monthly_commission: nextValue })
        } else if (prevValue != nextValue) {
            this.setState({ monthly_commission: nextValue })
        }
    }

    update = (e) => {
        const { agentInfo = {}, updateInfo } = this.props
        const { id } = agentInfo
        this.setState({ waiting: true }, () => {
            users.updateMonthlyCommission({ agent_id: id, monthly_commission: e.target.checked })
            .then(() => {
                return updateInfo()
            })
            .then(() => {
                this.setState({ monthly_commission: e.target.checked })
            })
            .catch((error) => {
                console.log(error.response);
                alertPopup({ type: 'error', title: 'העדכון נכשל', body: '' })
            })
            .finally(() => this.setState({ waiting: false }))
        })
    }

    render () {

        const { monthly_commission, waiting } = this.state
        const { agentInfo = {}, roles = [] } = this.props

        if (!roles.includes('admin') && !roles.includes('money')) {
            return agentInfo.monthly_commission ? <div style={{ ...style.box, borderRadius: '4px', color: 'red', fontWeight: 'bold' }}>{"עמלה חודשית"}</div> : ''
        }
        return (
            <div style={{ ...style.outer }}>
                <div style={{ ...style.box, ...style.rightBox }}>
                    {waiting ?  <Spin size={'small'}/> :
                    <Checkbox checked={monthly_commission} onChange={this.update}/>}
                </div>
                <div style={{ ...style.box, ...style.leftBox }}>
                    {"עמלה חודשית"}
                </div>
            </div>
        )
    }
}

const style = {
    outer: { display: 'flex' },
    box: {
        background: 'white',
        border: 'solid 1px #d1d1d1',
        height: '34px',
        paddingInline: '15px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center'
    },
    rightBox: { cursor: 'pointer', borderRadius: '0 4px 4px 0' },
    leftBox: { cursor: 'pointer', borderRadius: '4px 0 0 4px' }
}

export default CheckMonthlyCommission
